import {
    Box,
    chakra,
    Container,
    Stack,
    Text,
    useColorModeValue,
    VisuallyHidden,
  } from '@chakra-ui/react';
  import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
  import { ReactNode } from 'react';
  
const SocialButton = ({
        children,
        label,
        href,
    }) => {
    return (
        <chakra.button
            bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.100')}
            rounded={'full'}
            w={10}
            h={10}
            cursor={'pointer'}
            as={'a'}
            href={href}
            display={'inline-flex'}
            alignItems={'center'}
            justifyContent={'center'}
            transition={'background 0.3s ease'}
            _hover={{
                bg: useColorModeValue('blackAlpha.200', 'whiteAlpha.200'),
            }}
        >
        <VisuallyHidden>{label}</VisuallyHidden>
        {children}
        </chakra.button>
    );
};
  
  export default function Footer() {
    return (
      <Box
        bg={"#131514"}
        color={"#fff"}
        fontSize="lg"
      >
        <Container
          as={Stack}
          maxW={'100%'}
          py={4}
          direction={{ base: 'column', md: 'row' }}
          spacing={4}
          justify={{ base: 'center', md: 'space-between' }}
          align={{ base: 'center', md: 'center' }}>
          <Text>© 2021 Hack+Policy Foundation. All rights reserved</Text>
          <Stack direction={'row'} spacing={6}>
            <SocialButton label={'Twitter'} href={"https://twitter.com/hackpolicyfdn"}>
              <FaTwitter />
            </SocialButton>
            <SocialButton label={'Instagram'} href={"https://www.instagram.com/hackpolicyfoundation/"}>
              <FaInstagram />
            </SocialButton>
            {/* <SocialButton label={'YouTube'} href={'#'}>
              <FaYoutube />
            </SocialButton> */}
          </Stack>
        </Container>
      </Box>
    );
  }